import { PointLocation } from "./LockerDataTypes";

export interface IMapCenter { 
    value: any;
    order: number;
    IsApplicable: () => boolean;
    Run: () => Promise<PointLocation>;
}
export enum MapCenterType {
    romaniaMapCenter = "RomaniaMapCenter",
    hungaryMapCenter = "HungaryMapCenter",
    bulgariaMapCenter = "BulgariaMapCenter",
    unknownFavouriteLockerMapCenter = "UnknownFavouriteLockerMapCenter",
    homeFavouriteLockerMapCenter = "HomeFavouriteLockerMapCenter",
    workFavouriteLockerMapCenter = "WorkFavouriteLockerMapCenter",
    countyMapCenter = "CountyMapCenter",
    cityMapCenter = "CityMapCenter",
}

export interface MapCenterStrategy {
    name: MapCenterType;
    implementation: IMapCenter;
}